import Header from './utill/Header'
import Footer from './utill/Footer'
import Sidebar from './utill/Sidebar'
import {Button, Card, Form, Table} from "react-bootstrap";
import React, {ChangeEvent, useContext, useEffect, useState} from "react";
import axios from "axios";
import Pagination from "./utill/Pagination";
import Url from "./utill/Url";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {reissue} from "./utill/UtilComponent";
import {
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TableBody
} from "@mui/material";
import { RootState } from '../redux/store';
import StyledTableCell from "./utill/StyledTableCell"

interface deleteUser {
    id: number;
    serialNumber: string;
    phoneNumber: string;
    cancelDtm: string;
}

function DeletedUserManagement() {


    const url = useContext(Url);
    const navigate = useNavigate();
    const [data, setData] = useState<deleteUser[]>([]);
    const [totalData, setTotalData] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [textCurrentPage, setTextCurrentPage] = useState('');
    const [selected, setSelected] = useState("1");
    const [searchText, setSearchText] = useState('');
    const user = useSelector((state: RootState) => state.user.value);
    const [listSelected, setListSelected] = useState("15");
    const [searchedData, setSearchedData] = useState('');
    const [selectType, setSelectType] = useState("1");
    const auth = useSelector((state: RootState) => state.loginAuth.value);

    let userId = user.id;

    useEffect(() => {
        document.title = 'Mcon 모니터링 시스템-해지 사용자 관리'
        if (auth.MENUAUTH?.DUSR0000?.readAuthorityYn !== "1") {
            alert('페이지를 볼 수 있는 권한이 없습니다.');
            navigate(auth.firstUrl);
        }
    }, [])

    // 페이지 변경 이벤트 핸들러
    const handlePageChange = (page: number) => {
        setCurrentPage(page);
        setTextCurrentPage(page.toString());
    };

    useEffect(() => {
        reissue(userId, url, navigate).then(() => {
            axios.get(url + 'cancel/find', {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                },
                params: {
                    type: selectType,
                    data: searchedData,
                    page: currentPage,
                    listCnt: listSelected
                }
            })
                .then((response) => {
                    setData(response.data.result.data)
                    setTotalData(response.data.result.totalData)
                    setTotalPages(response.data.result.totalPage)
                })
        })
    }, [currentPage, listSelected])

    useEffect(() => {
        setCurrentPage(1);
        setTextCurrentPage('1');
    }, [listSelected]);

    const handleSubmit = async () => {
        let data!: string;
        setCurrentPage(1);
        setTextCurrentPage('1');
        setSelectType(selected)
        if (selected === "1") {
            data = searchText
        } else if (selected === "2") {
            if (handleInputChange(searchText)){
                data = searchText
            }else {
                return;
            }
        }
        setSearchedData(data)
        reissue(userId, url, navigate).then(() => {
            axios.get(url + 'cancel/find', {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                },
                params: {
                    type: selected,
                    data: data,
                    page: 1,
                    listCnt: listSelected
                }
            }).then((response) => {
                setData(response.data.result.data);
                setTotalData(response.data.result.totalData);
                if (response.data.result.totalPage !== 'undefined') {
                    setTotalPages(response.data.result.totalPage);
                } else {
                    setTotalPages(1)
                }
            })
        })
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const key = e.code;
        if (key === 'Enter' || key === 'NumpadEnter') {
            e.preventDefault();
            handleSubmit();
        }
    }

    const handleCurrentPageText = () => {
        const numericValue = parseInt(textCurrentPage, 10);
        if (!isNaN(numericValue) && numericValue > 0 && numericValue <= totalPages) {
            // 숫자인 경우
            setCurrentPage(numericValue);
        } else if(numericValue >= totalPages){
            alert('총 페이지 보다 높은 수를 입력하실 수 없습니다')
        }else {
            // 숫자가 아닌 경우
            alert("숫자만 입력 가능합니다.");
        }
    };

    const handleInputChange = (num: string) => {
        if (/^[0-9 -]*$/.test(num) || num === '') {
            return true
        }else {
            alert('휴대전화번호로 검색은 숫자, "-", " " 만 입력하실 수 있습니다.')
            return false
        }
    };

    const handleChangeListSelect = (e: ChangeEvent<HTMLSelectElement>) => {
        setListSelected(e.target.value);
    }

    const handleChangeSelect = (e: ChangeEvent<HTMLSelectElement>) => {
        setSelected(e.target.value)
    }

    let selectedValueTitle = "";
    let selectedValueContent = "";
    let textState = "active";

    if (selected === "1") {
        selectedValueTitle = "시리얼번호로";
        selectedValueContent = "시리얼번호를";
    } else if (selected === "2") {
        selectedValueTitle = "휴대전화번호로";
        selectedValueContent = "휴대전화번호를";
    }

    function encPhoneNumber(phone: string) {
        return phone.replaceAll(" ", "")
            .replaceAll("-", "")
            .replaceAll("0", "an")
            .replaceAll("1", "%")
            .replaceAll("2", "*")
            .replaceAll("3", "dk")
            .replaceAll("4", "eh")
            .replaceAll("5", "^)")
            .replaceAll("6", "gs")
            .replaceAll("7", "$@")
            .replaceAll("8", "il")
            .replaceAll("9", "!#");
    }

    function decPhoneNumber(phonenumber: string) {
        if(phonenumber.startsWith("MCONT")) {
            return phonenumber;
        }

        let hiddenphonenumber = phonenumber.slice(0,-4) + phonenumber.slice(-4).replace(/[0-9]/g,'*')
        // 핸드폰 번호에 하이픈(-) 추가
        if (hiddenphonenumber.length === 10) {
            // 10자리 핸드폰 번호인 경우
            return hiddenphonenumber.replace(/(\d{3})(\d{3})(\D{4})/, '$1-$2-$3');
        } else if (hiddenphonenumber.length === 11) {
            // 11자리 핸드폰 번호인 경우
            return hiddenphonenumber.replace(/(\d{3})(\d{4})(\D{4})/, '$1-$2-$3');
        } else {
            // 그 외의 경우, 형식을 변경하지 않고 반환
            return hiddenphonenumber;
        }
    }

    

    return (
        <div id="wrapper">
            <Sidebar menuCode={"DUSR0000"}/>
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <div className="container-fluid">
                        <Header pageName='해지 사용자 관리'/>
                        <Card className="card shadow mb-4"
                              style={{minHeight: "780px"}}>
                            <Card.Header className="py-3">
                                <h6 className="m-0 font-weight-bold text-primary">{selectedValueTitle} 검색</h6>
                                <p className="mb-2 mt-2 basic_font">{selectedValueContent} 기준으로 조회 합니다.</p>
                                <Form id="searchForm">
                                    <div className='form-group row'>
                                        <div className='search_area'>
                                            <Form.Select className='select_box' id='search_select' value={selected}
                                                         onChange={handleChangeSelect}>
                                                <option value="1">시리얼번호</option>
                                                <option value="2">휴대전화번호</option>
                                            </Form.Select>
                                            <Form.Control type="text" id={textState} value={searchText}
                                                          onChange={(e) => setSearchText(e.target.value)}
                                                          onKeyDown={handleKeyDown}/>
                                        </div>
                                        <div className='search_button_area'>
                                            <Button variant="primary" className='search_button'
                                                    onClick={handleSubmit}>검색</Button>
                                        </div>
                                    </div>
                                </Form>
                            </Card.Header>
                            <Card.Body>
                                <div style={{display: "flex", marginBottom: "5px"}}>
                                    <p className="card-body_content"
                                       style={{display: "flex", alignItems: "center", margin: "0 10px 0 0"}}>검색 결과 :
                                        총 {totalData}건</p>
                                    <Form.Select className="select_box" id='search_select' value={listSelected}
                                                 onChange={handleChangeListSelect}>
                                        <option value="15">15개</option>
                                        <option value="30">30개</option>
                                        <option value="50">50개</option>
                                        <option value="100">100개</option>
                                    </Form.Select>
                                </div>
                                <TableContainer component={Paper}>
                                    <Table style={{marginBottom: 0}} aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell align="center">시리얼번호</StyledTableCell>
                                                <StyledTableCell align="center">휴대전화번호</StyledTableCell>
                                                <StyledTableCell align="center">해지일시</StyledTableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                        {data.map(cancel => (
                                                <TableRow key={cancel.id}>
                                                    <StyledTableCell align="center">{cancel.serialNumber || "-"}</StyledTableCell>
                                                    <StyledTableCell
                                                        align="center">{decPhoneNumber(cancel.phoneNumber) || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{cancel.cancelDtm || "-"}</StyledTableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Card.Body>
                        </Card>
                        <div>
                            <Pagination
                                totalPages={totalPages}
                                currentPage={currentPage}
                                onPageChange={handlePageChange}>
                            </Pagination>
                            <div style={{display: "flex", justifyContent: "center", marginBottom: '1rem'}}>
                                <Form.Control className="currentForm" value={textCurrentPage}
                                              onChange={(e) => setTextCurrentPage(e.target.value)}/>
                                <button className="btn btn-primary currentButton" onClick={handleCurrentPageText}>
                                    <span>이동</span></button>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer/>
            </div>
        </div>
    );
}

export default DeletedUserManagement;